<template>
  <!-- 今日统计 -->
  <div class="todayAccountPart">
    <div class="dataDetailBox">
      <!-- 上 -->
      <div class="dataDetail">
        <!-- 总览 -->
        <div class="left">
          <div class="content">
            <div class="title" @click="goTodayDetail(status=0)">
              <div class>日销售额({{todayData.count}}单)</div>
              <div>
                <md-icon name="arrow-right" size="sm"></md-icon>
              </div>
            </div>
            <div class="price">
              <span>￥</span>
              <span>{{todayData.turnover*1}}</span>
            </div>
            <div class="time">未还总额：￥{{todayData.total_credit_money*1}}</div>
            <div class="acountLine"></div>
            <div class="real_money" @click="goRealAcount">
              <div class="tl">
                <div>
                  <span>日实收额</span>
                  <span>（支出未扣除）</span>
                </div>
                <div>
                  <md-icon name="arrow-right" size="sm"></md-icon>
                </div>
              </div>
              <div>
                <span>￥</span>
                <span>{{todayData.total_payment*1}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 明细 -->
        <div class="right">
          <div class="part1">
            <div class="card" @click="goTodayDetail(status=0)">
              <div>订单实收额</div>
              <div>
                <span>￥</span>
                <span>{{todayData.payment*1}}</span>
              </div>
            </div>
            <div @click="goTodayDetail(status=1)">
              <div>订单赊欠额</div>
              <div>
                <span>￥</span>
                <span>{{todayData.credit_amount*1}}</span>
              </div>
            </div>
            <div @click="goTodayDetail(status=2)">
              <div>
                <span>今日还款</span>
                <span style="font-size:0.12rem">(其中还款优惠￥{{todayData.repayment_discount_amount*1}})</span>
              </div>
              <div>
                <span>￥</span>
                <span>{{todayData.repayment*1}}</span>
              </div>
            </div>
            <div @click="goTodayDetail(status=0)">
              <div v-if="todayData.discount<=0">订单优惠</div>
              <div v-if="todayData.discount>0">订单多收</div>
              <div>
                <span>￥</span>
                <span>{{Math.abs(todayData.discount)}}</span>
              </div>
            </div>
          </div>
          <div class="part2">
            <span>对账小公式：</span>
            <span style="margin-right:0.4rem">日销售额=订单实收+订单赊欠</span>
            <span>日实收额=订单实收+今日还款-还款优惠</span>
          </div>
          <div class="part3">
            <div class="cashBox" v-for="(item,index) in todayData.pay_channels" :key="index">
              <!--  -->
              <div class="cash">
                <div class="tl">
                  <div>
                    <img :src="payType[index].icon" alt />
                    <span>{{item.label}}</span>
                  </div>
                  <!-- <div>
                    <md-icon name="arrow-right" size="xs" style="font-size: 0.24rem;"></md-icon>
                  </div>-->
                </div>
                <div class="mon">
                  <span>￥</span>
                  <span>{{item.v*1}}</span>
                </div>
              </div>
              <div class="mline" v-if="index!=todayData.pay_channels.length-1"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 下 -->
      <div class="orderDetailBox">
        <!-- 左 -->
        <div class="left">
          <div class="orderTitle">
            <div></div>
            <div>单据统计</div>
          </div>
          <div class="orderDetail">
            <!--  @click="goTodayDetail(index,item.label)" -->
            <div class="returnOrder" v-for="(item,index) in todayData.order" :key="index">
              <div>
                <span>{{item.label}}</span>
                <!-- <md-icon name="arrow-right" size="xs" style="font-size: 0.24rem;"></md-icon> -->
              </div>
              <div>
                <span>{{item.v}}</span>
                <span>单</span>
              </div>
            </div>
            <!-- <div class="mline"></div> -->
          </div>
        </div>
        <!-- 右 -->
        <div class="right">
          <div class="orderTitle">
            <div></div>
            <div>成本统计</div>
          </div>
          <div class="costStatistics">
            <div v-for="(item,index) in todayData.goods" :key="index">
              <div>{{item.label}}</div>
              <div>
                <span>￥</span>
                {{item.v*1}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { today_acount } from "@/api/work/acount/todayAcount";
export default {
  name: "todayAccountPart",
  data() {
    return {
      payType: [
        {
          i: 1,
          value: "现金",
          icon: require("@/assets/img/data/data_cash.png"),
        },
        {
          i: 2,
          value: "支付宝",
          icon: require("@/assets/img/data/data_aliPay.png"),
        },
        {
          i: 3,
          value: "微信",
          icon: require("@/assets/img/data/data_wechat.png"),
        },
        {
          i: 4,
          value: "银行卡",
          icon: require("@/assets/img/data/data_card.png"),
        },
        {
          i: 5,
          value: "POS支付",
          icon: require("@/assets/img/data/data_POS.png"),
        },
      ],
      todayData: {
        count: "",
        credit_amount: "",
        discount: "",
        goods: [],
        order: [],
        pay_channels: [],
        payment: "",
        repayment: "",
        repayment_discount_amount: "",
        total_credit_money: "",
        total_payment: "",
        turnover: "",
      }, //今日统计数据
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    //获取今日统计数据
    getData() {
      today_acount({}).then((res) => {
        if (res.code == 200) {
          this.todayData.count = res.data.count || 0;
          this.todayData.credit_amount = res.data.credit_amount || 0;
          this.todayData.discount = res.data.discount || 0;
          this.todayData.payment = res.data.payment || 0;
          this.todayData.repayment = res.data.repayment || 0;
          this.todayData.repayment_discount_amount =
            res.data.repayment_discount_amount || 0;
          this.todayData.total_credit_money = res.data.total_credit_money || 0;
          this.todayData.total_payment = res.data.total_payment || 0;
          this.todayData.turnover = res.data.turnover || 0;
          this.todayData.goods = res.data.goods || [];
          this.todayData.order = res.data.order || [];
          this.todayData.pay_channels = res.data.pay_channels || [];
        }
      });
    },
    //去日订单列表
    goTodayDetail(status, name) {
      // console.log("--status--", status, name);
      if (name) {
        if (name == "作废数") {
          status = 3;
        } else if (name == "退单数") {
          status = 4;
        } else if (name == "改单数") {
          status = 5;
        }
      }
      this.$router.push({
        path: "/data/todayAcount/todayAcountDetail",
        query: {
          status,
        },
      });
    },
    //去日实收列表
    goRealAcount() {
      this.$router.push({
        path: "/data/todayAcount/netReceiptsAcount",
        query: {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
// 今日统计
.todayAccountPart {
  padding: 0.2rem;
  background: #fff;
  border-radius: 0.1rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-bottom: 0;
  height: 100%;
  .dataDetailBox {
    .dataDetail {
      display: flex;
      .left {
        width: 4rem;
        height: 3.6rem;
        padding: 0.2rem;
        background: url("../../../../assets/img/data/total_data_bg.png")
          no-repeat;
        background-size: 100% 100%;
        .content {
          color: #fff;
          .title {
            display: flex;
            margin-top: 0.09rem;
            justify-content: space-between;
            color: #fff;
            font-size: 0.24rem;
            div:nth-of-type(2) {
              margin-top: 0.02rem;
            }
          }
          .price {
            margin-top: 0.2rem;
            span:nth-of-type(1) {
              font-size: 0.24rem;
            }
            span:nth-of-type(2) {
              font-size: 0.38rem;
              font-weight: bold;
            }
          }
          .time {
            font-size: 0.2rem;
          }
          .acountLine{
            width: 100%;
            height: 0.01rem;
            background: #fff;
            margin:0.2rem 0;
          }
          .real_money {
            
            .tl {
              display: flex;
              justify-content: space-between;
              align-items: center;
              > div:nth-of-type(1) {
                font-size: 0.24rem;
                > span:nth-of-type(2) {
                  font-size: 0.18rem;
                }
              }
              >div:nth-of-type(2){
                margin-top: 0.08rem;
              }
            }
            >:nth-of-type(2){
              margin-top:0.2rem;
              >span:nth-of-type(2){
                font-size: 0.38rem;
                font-weight: bold;
              }
            }
          }
        }
      }
      .right {
        margin-left: 0.2rem;
        border-bottom: 0.01rem solid #e5e5e5;
        width: 100%;
        .part1 {
          display: flex;
          justify-content: space-between;
          > div {
            width: 2.15rem;
            height: 0.96rem;
            color: #fff;
            > div:nth-of-type(1) {
              font-size: 0.14rem;
              margin-top: 0.1rem;
              margin-left: 0.1rem;
            }
            > div:nth-of-type(2) {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 0.14rem;
              span:nth-of-type(1) {
                font-size: 0.18rem;
                margin-top: 0.04rem;
              }
              span:nth-of-type(2) {
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
          }
          > div:nth-of-type(1) {
            background: url("../../../../assets/img/data/real_data_bg.png")
              no-repeat;
            background-size: 100% 100%;
          }
          > div:nth-of-type(2) {
            background: url("../../../../assets/img/data/credit_data_bg.png")
              no-repeat;
            background-size: 100% 100%;
          }
          > div:nth-of-type(3) {
            background: url("../../../../assets/img/data/today_payBack_data_bg.png")
              no-repeat;
            background-size: 100% 100%;
          }
          > div:nth-of-type(4) {
            background: url("../../../../assets/img/data/benefit_data_bg.png")
              no-repeat;
            background-size: 100% 100%;
          }
        }
        .part2 {
          display: flex;
          justify-content: flex-end;
          margin-top: 0.2rem;
          margin-bottom: 0.58rem;
          color: #999999;
          font-size: 0.18rem;
        }
        .part3 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 9rem;
          .cashBox {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            .cash {
              margin-right: 0.04;
              width: 100%;
              .tl {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 0.42rem;
                > div:nth-of-type(1) {
                  display: flex;
                  align-items: center;
                  img {
                    width: 0.38rem;
                    height: 0.29rem;
                    margin-right: 0.1rem;
                    margin-top: 0.02rem;
                  }
                  span {
                    font-size: 0.24rem;
                    color: #404040;
                    // margin-right: 0.2rem;
                  }
                }
                > div:nth-of-type(2) {
                  color: #999999;
                }
              }
              .mon {
                color: #404040;
                font-weight: bold;
                text-align: center;
                span:nth-of-type(1) {
                  font-size: 0.18rem;
                  text-align: center;
                }
              }
            }
          }
          .mline {
            width: 0.01rem;
            height: 0.76rem;
            background: #e5e5e5;
            margin-right: 0.12rem;
            margin-left: 0.12rem;
          }
        }
      }
    }
    // 下面统计方面
    .orderDetailBox {
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding-top: 0.39rem;
      padding-left: 0.2rem;
      .orderTitle {
        display: flex;
        align-items: center;
        color: #404040;
        font-size: 0.28rem;
        font-weight: bold;
        margin-bottom: 0.48rem;
        > div:nth-of-type(1) {
          width: 0.08rem;
          height: 0.25rem;
          margin-right: 0.15rem;
          background: #31b158;
        }
      }
      .left {
        width: 50%;
        .orderDetail {
          display: flex;
          justify-content: space-around;
          align-items: center;
          .mline {
            width: 0.01rem;
            height: 0.76rem;
            background: #e5e5e5;
          }
          .returnOrder {
            color: #666666;
            display: flex;
            flex-direction: column;
            align-items: center;
            > div:nth-of-type(1) {
              margin-bottom: 0.26rem;
            }
          }
        }
      }
      .right {
        width: 50%;
        margin-left: 0.4rem;
        .costStatistics {
          display: flex;
          align-items: center;
          justify-content: space-around;
          color: #31b158;
          > div {
            > div:nth-of-type(1) {
              margin-bottom: 0.26rem;
              text-align: center;
            }
            > div:nth-of-type(2) {
              font-size: 0.28rem;
              font-weight: bold;
              text-align: center;
            }
            span {
              font-size: 0.2rem;
            }
          }
        }
      }
    }
  }
}
</style>